// src/LanguageLayout.tsx
import { useEffect } from 'react';
import { useParams, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function LanguageLayout() {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  // <Outlet /> sẽ render các trang con của bạn (HomePage, ProductsPage,...)
  return <Outlet />;
}

export default LanguageLayout;